import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row,
} from "reactstrap";
import img2 from "../../../../assets/images/Travel/Annapurna.png";
import BookModalForm from "../Destination/Component/BookModalForm";
import '../../../../common/style.css';

// const tripData = [
//   {
//     id: 1,
//     title: "Annapurna Base Camp Trek",
//     duration: "5 days",
//     package: "Trekking",
//     price: "US$680",
//     img: img2, // Replace with the actual image import
//   },
//   {
//     id: 2,
//     title: "Everest Base Camp Trek",
//     duration: "12 days",
//     package: "Trekking",
//     price: "US$1,200",
//     img: img2, // Replace with the actual image import
//   },
//   {
//     id: 3,
//     title: "Langtang Valley Trek",
//     duration: "7 days",
//     package: "Trekking",
//     price: "US$800",
//     img: img2, // Replace with the actual image import
//   },
//   {
//     id: 4,
//     title: "Langtang Valley Trek",
//     duration: "7 days",
//     package: "Trekking",
//     price: "US$800",
//     img: img2, // Replace with the actual image import
//   },
//   {
//     id: 5,
//     title: "Langtang Valley Trek",
//     duration: "7 days",
//     package: "Trekking",
//     price: "US$800",
//     img: img2, // Replace with the actual image import
//   },
// ];

const BookNow = ({ data, packageTitle }) => {
  // If no data, return null (i.e., don't render the component)
  if (!data || data.length === 0) {
    return null;
  }

  console.log("🚀 ~ BookNow ~ data:", data);

  // State to control how many trips are displayed
  const [visibleTrips, setVisibleTrips] = useState(3); // Show 3 trips initially
  const trips = data?.slice
    ? data.slice(0, visibleTrips)
    : data?.trips?.slice(0, visibleTrips);
  console.log("🚀 ~ BookNow ~ trips:", trips);

  // Function to handle "Show More" button click
  const handleShowMore = () => {
    setVisibleTrips((prevVisibleTrips) => prevVisibleTrips + 3); // Increase the visible trips by 3
  };

  // Function to handle "Show Less" button click
  const handleShowLess = () => {
    setVisibleTrips((prevVisibleTrips) =>
      prevVisibleTrips - 3 < 3 ? 3 : prevVisibleTrips - 3
    ); // Decrease visible trips but not less than initial count
  };

  const [bookModal, setBookModal] = useState(false);

  const bookToggle = () => setBookModal(!bookModal);

  return (
    <div className="m-0 p-0 mb-5">
      {!data || (
        <div className="d-flex justify-content-center align-content-center mb-3">
          <h1>{packageTitle}</h1>
        </div>
      )}
      <Row className="g-3">
        {trips?.map((trip) => (
          <Col
            xs={12} // Full width on extra small screens
            sm={6} // Half width on small screens
            md={4} // One-third width on medium screens
            lg={4}
            key={trip.id}
          >
            <Card className="p-0 h-100 card-border-radius">
            <img
                className="card-img-top img-fluid w-100 card-image-border-radius"
                src={trip.banner_image_url || "path/to/placeholder-image.jpg"}
                alt={trip.name || "Placeholder Image"}
              />

              <CardBody className="d-flex flex-column ">
                <h4 className="card-title mb-2">
                  {trip.name || "No Title Available"}
                </h4>
                <ul
                  className="list-unstyled flex-grow-1"
                  style={{ lineHeight: "25px" }}
                >
                  {trip.duration ? (
                    <li className="d-flex gap-2">
                      <i className="ri-time-line"></i> Duration:
                      <span>{trip.duration}</span>
                    </li>
                  ) : (
                    <li className="d-flex gap-2 text-muted"></li>
                  )}

                  {trip?.trip ? (
                    <li className="d-flex gap-2">
                      <i className="ri-walk-line"></i> Trip:
                      <span>{trip.trip}</span>
                    </li>
                  ) : (
                    <li className="d-flex gap-2 text-muted"></li>
                  )}

                  {trip.price ? (
                    <li className="d-flex gap-2">
                      <i className="ri-price-tag-3-fill"></i>
                      Price: starting from
                      <span className="text-info fw-bold">US$ {trip.price}</span>
                    </li>
                  ) : (
                    <li className="d-flex gap-2 text-muted"></li>
                  )}
                </ul>
                <div className="d-flex gap-2">
                  <Link
                    to={`/packages/${trip.slug || "#"}`}
                    className="btn btn-outline-info w-100 text-center"
                  >
                    View Deal
                  </Link>

                  <button
                    type="button"
                    className="btn btn-info w-100"
                    onClick={() => bookToggle(trip.id)}
                    disabled={!trip.id}
                  >
                    Book
                  </button>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Show More or Show Less button */}
      <div className="d-flex justify-content-center mt-3">
        {visibleTrips < data?.trips?.length ? (
          <h6 onClick={handleShowMore} className="link cursor-pointer">
            View All trips
          </h6>
        ) : (
          <h6 onClick={handleShowLess} className="link cursor-pointer">
            Show Less
          </h6>
        )}
      </div>

      <BookModalForm toggle={bookToggle} modal={bookModal} />
    </div>
  );
};

export default BookNow;
